import { render, staticRenderFns } from "./Attachments.vue?vue&type=template&id=bf979a9a&scoped=true"
import script from "./Attachments.vue?vue&type=script&lang=js"
export * from "./Attachments.vue?vue&type=script&lang=js"
import style0 from "./Attachments.vue?vue&type=style&index=0&id=bf979a9a&prod&scoped=true&lang=css"
import style1 from "./Attachments.vue?vue&type=style&index=1&id=bf979a9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf979a9a",
  null
  
)

export default component.exports